// ui/presenters/modifierOptions.js
import { i18n } from 'boot/i18n';

import { CREDENTIAL_MODIFIER_SUGGESTIONS, MODIFIER_SUGGESTIONS } from '../../domain/constants/modifier';

/**
 * The modifier suggestion lists as a picker reads them.
 *
 * HERE RATHER THAN IN `domain/`, for the reason `credentialingOptions` gives next door: what a
 * modifier MEANS is translated, and a constant that imported `boot/i18n` would be the dependency
 * pointing the wrong way. The constant keeps what is a fact about billing — which modifiers to
 * offer and which families to withhold — and this resolves the words.
 *
 * THE LABEL IS THE CODE, IN EVERY LANGUAGE. HCPCS is one published vocabulary and a payer rejects
 * anything but the literal two characters, so only the caption varies.
 */

const toOption = (suggestion) => ({
  value: suggestion.value,
  label: suggestion.value,
  caption: i18n.t(`modifierSuggestions.${suggestion.captionKey}`),
});

/** The payer's unconditional set: what this service codes as whoever delivered it. */
export const modifierSuggestionOptions = () => MODIFIER_SUGGESTIONS.map(toOption);

/** The credential tier: what the performer's qualifications earn the line. */
export const credentialModifierOptions = () => CREDENTIAL_MODIFIER_SUGGESTIONS.map(toOption);
